module.exports = "/assets/f8bfb49a47aceaffe774bea292eb6372.svg";